import React from "react";
import "../styles/components/gsm_card.css";

const GsmCard = ({ name, price, colorClass }) => {
  return (
    <div className={`gsm-card`}>
        <div className="gsm-card__info">
            <div className="gsm-card__name">{name}</div>
            <div className="gsm-card__price">{price} сом</div>
        </div>
        <span className={`card-color_circle ${colorClass}`}></span>
    </div>
  );
};

export default GsmCard;
